export type ReportType =
  | "salesOverviewReport"
  | "transactionsOverviewReport"
  | "payoutReport"
  | "accountingReport";
export type AnalyticsReportType =
  | "applePerformanceReport"
  | "mainAnalyticsReport";
export type PartnerReportType =
  | "resellerMarkupReport"
  | "softwareVendorMarkupReport";

export type FormatType = "PDF" | "JSON" | "XLSX" | "CSV" | "TSV";

export enum ReportName {
  DescriptorReport = "descriptorReport",
  MerchantOverviewReport = "merchantOverviewReport",
  SalesCommissionReport = "salesCommisionReport",
  ChannelCountReport = "channelCountReport",
  ChannelVolumesReport = "channelVolumesReport",
  VerticalReport = "verticalReport", //ignore
  VerticalByChannelReport = "verticalByChannelReport", //ignore
  TPVSegmentationReport = "TPVSegmentationReport", //ignore
  RestaurantTPVSegmentationReport = "restuarantTPVSegmentationReport",
  PartnerAnalysisReport = "partnerAnalysisReport",
  MerchantVolumeReport = "merchantVolumeReport",
  MerchantGrossRevenueReport = "merchantGrossRevenueReport",
  MerchantNetRevenueReport = "merchantNetRevenueReport",
  MerchantNetRevenueAfterMarkupReport = "merchantNetRevenueAfterMarkupReport",
  CardFeesReport = "CardFeesReportReport",
}

export const ReportNameLabels: Record<ReportName, string> = {
  [ReportName.DescriptorReport]: "Descriptor Report",
  [ReportName.MerchantOverviewReport]: "Merchant Overview Report",
  [ReportName.SalesCommissionReport]: "Sales Commission Report",
  [ReportName.ChannelCountReport]: "Channel Count Report",
  [ReportName.ChannelVolumesReport]: "Channel Volumes Report",
  [ReportName.VerticalReport]: "Vertical Report",
  [ReportName.VerticalByChannelReport]: "Vertical By Channel Report",
  [ReportName.TPVSegmentationReport]: "TPV Segmentation Report",
  [ReportName.RestaurantTPVSegmentationReport]:
    "Restaurant TPV Segmentation Report",
  [ReportName.PartnerAnalysisReport]: "Partner Analysis Report",
  [ReportName.MerchantVolumeReport]: "Merchant Volume Report",
  [ReportName.MerchantGrossRevenueReport]: "Merchant Gross Revenue Report",
  [ReportName.MerchantNetRevenueReport]: "Merchant Net Revenue Report",
  [ReportName.MerchantNetRevenueAfterMarkupReport]:
    "Merchant Net Revenue After Markup Report",
  [ReportName.CardFeesReport]: "Card Fees Report",
};

export interface IReport {
  type: string;
  formatTypes: FormatType[];
  label: string;
  previewUrl?: string;
  description?: string;
  isBeta?: boolean;
  warning?: string;
}
export interface IMerchantReport extends IReport {
  type: ReportType;
}
export interface IAnalyticsReport extends IReport {
  type: AnalyticsReportType;
}
export interface IPartnerReport extends IReport {
  type: PartnerReportType;
}

export interface IReportResponse {
  transactionsReport?: string | null;
  report?: string | null;
  isEmailed: boolean;
  isEmpty: boolean;
}
